import { render, staticRenderFns } from "./ProjectComponents.vue?vue&type=template&id=096811d6&"
import script from "./ProjectComponents.vue?vue&type=script&lang=js&"
export * from "./ProjectComponents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports